<template>
    <div v-show="$appSettings.chatEnabled" class="bootstrap-iso" :style="{'bottom': $appSettings.verticalPlacement}">
        <chat-popup
            :enabled="$appSettings.autoPromptEnabled"
            :message="myhtml"
            :delayInSeconds="$appSettings.popupDelaySecs"
        ></chat-popup>
        <chat-launcher></chat-launcher>
        <chat-start></chat-start>
        <chat-client></chat-client>
        <chat-transcript></chat-transcript>
    </div>
</template>
<script>
import screenNavMixin from '../mixins/screen-nav';

import ChatPopupComponent from '../components/chat-popup';
import ChatButtonComponent from '../components/chat-button';
import ChatStartComponent from '../components/chat-start';
import ChatClientComponent from '../components/chat-client';
import ChatTranscriptComponent from '../components/chat-transcript';

export default {
     mixins: [screenNavMixin],
        components: {
            'chat-popup': ChatPopupComponent,
            'chat-launcher': ChatButtonComponent,
            'chat-start': ChatStartComponent,
            'chat-client': ChatClientComponent,
            'chat-transcript': ChatTranscriptComponent
        },
        data(){
            return {
                myhtml: this.$appSettings.autoPromptMessage
            }
        }
}
</script>

<style>
    /* GLOBAL */
    body .bootstrap-iso {
        width: 350px;
        background: transparent;
        position: fixed;
        z-index: 4000;
        right: 10px;
    }

    .bootstrap-iso .branding-background {
        background-color: #333;
    }

    .bootstrap-iso .branding-text, .bootstrap-iso button.branding-text:hover, .bootstrap-iso a.branding-text:hover {
        color: #ddd;
    } 

    .bootstrap-iso button.btn, .bootstrap-iso .panel, .bootstrap-iso .chat-reply textarea {
        border: 1px solid #ddd;
    }

    .bootstrap-iso a {
        color: #333;
    }

    .bootstrap-iso button.branding-text:hover, .bootstrap-iso a.branding-text:hover {
        opacity: 0.8;
    }

    /* LAUNCHER BUTTON */
    .bootstrap-iso button.chat-toggle {
        position: absolute;
        padding: 10px 20px;
        right: -40px;
        bottom: 52px;
        z-index: 1001;
        transform: rotate(-90deg);
        font-size: 20px;
        border-radius: 11px 11px 0 0;
        box-shadow: 0 -2px 10px rgba(0 0 0 / 50%);
    }

    /* POPUP START CHAT */
    .bootstrap-iso .chat-toggle-popover {
        max-width: 325px;
        float:right;
    }

    .bootstrap-iso .chat-toggle-popover .panel {
        border-radius: 11px 11px 11px 0;
        word-break: break-word;
        white-space: pre-line;
    }

    .bootstrap-iso .chat-toggle-popover a {
        margin-left: 15px;
    }

    /* END CHAT */
    .chat-end {
        position: absolute;
        z-index: 3;
        top: 0;
        right: 0;
        bottom: 20px;
        left: 0;
    }

    .chat-end h3 {
        margin-top:100px;
    }

    .bootstrap-iso .chat-end {
        background: rgba(0 0 0 / 60%);
        color: #fff;
    }

    .bootstrap-iso .chat-end .btn {
        border: 0;
        margin: 0 15px;
    }

    /* CHAT CLIENT UI */
    .bootstrap-iso .chat-window {
        height: 250px;
        overflow-y: auto;
        background-color: #f5f5f5;
    }

    .bootstrap-iso .chat-window .panel-body {
        padding-top: 5px 10px 5px 10px;
    }

     .bootstrap-iso .chat-window .panel{
        margin-bottom: 5px;
    }

    .bootstrap-iso .panel-heading, .bootstrap-iso .chat-window {
        border-bottom: 1px solid #ddd;
    }

    .bootstrap-iso .close-chat {
        margin-left: 15px;
    }

    .bootstrap-iso .panel.incoming-response, .panel.outgoing-response {
        max-width: 90%;
        border-radius: 11px;
    }

    .bootstrap-iso .panel.incoming-response {
        background: #fff;
        border-bottom-left-radius: 0;
        float: left;
    }

    .bootstrap-iso .panel.outgoing-response {
        background: #e5e5e5;
        border-bottom-right-radius: 0;
        float: right;
    }

    .bootstrap-iso .incoming-response li:first-child {
        text-align: left;
    }

    .bootstrap-iso .timestamp-response {
        margin-top: 5px;
    }

    .bootstrap-iso .chat-row {
        display: block;
        width: 100%;
    }

    .bootstrap-iso .chat-reply .input-group-lg > .form-control {
        resize: none;
        font-size: 14px;
        padding: 4px;
    }

    .bootstrap-iso .bootstrap-iso .input-group-lg > .input-group-btn > .btn.send-response {
        font-size: 24px;
    }

</style>